import { listOption } from '@/api/base/baseWarehouse.js'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(listOption)
